import { useTranslation } from "react-i18next";
import { NavigationActionButton } from "../NavigationActionButton/NavigationActionButton";

export function RetailersButton(props) {
    const { t } = useTranslation();

    return (
        <NavigationActionButton
            href="/retailers"
            label={t("cta-retailers-button-label")}
            onClick={props.onClick}
            hoverTextClassName="hover:!text-white"
            className={`!bg-[#242D29] hover:!bg-[#313D38] !text-white !text-base whitespace-nowrap ${
                props.className ? props.className : ""
            }`}
        />
    );
}
